module.exports = __webpack_public_path__ + "static/scale-model-of-tom-watson-park-in-boulder-colorado-a40e346f2972a64c5ff21c05369decc7.png";